import { Paper } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  downloadCertificadoCobertura,
  enviarCertificadoCobertura,
  validarImportacionNominas,
} from "../../../redux/actions/certificadoCobertura";
import { downloadFile, parseBlobToObject } from "../../../util/files";
import Breadcrumb from "../../commons/breadcrumb/Breadcrumb";
import ErrorsDialog from "../../commons/dialog/ErrorsDialog";
import HeaderForm from "../../commons/labels/HeaderForm";
import { StyledBreadCrumb } from "../../styled/Breadcrumbs";
import ClausulaContainer from "./clausula/ClausulaContainer";
import NominaContainer from "./nomina/NominaContainer";


const CertificadoCoberturaContainer = () => {
  const dispatch = useDispatch();

  const [body, setBody] = useState({});
  const [form, setForm] = useState("InclusiónDeCláusulas");
  const [fromBread, setFromBread] = useState(false);
  const [breadcrumbFields, setBreadcrumbFields] = useState([form]);
  const [errorDialog, setErrorDialog] = useState(false);
  const [errorList, setErrorList] = useState([]);

  const handleNext = (clausulas, empresas) => {
    setBody({
      tiposClausulaCertificado: clausulas,
      subrogacionEmpresa: empresas,
    });
    handleSetForm("SelecciónDeNóminas");
  };

  const handleSetForm = (form) => {
    if (!breadcrumbFields.includes(form)) {
      setBreadcrumbFields([...breadcrumbFields, form]);
    }
    setForm(form);
  };

  const handleSubmit = (email, nominasValue, nominaList, nominaFile) => {
    const bodyObj = {
      ...body,
      nominas: nominaList,
      seleccionEmpleados: parseInt(nominasValue),
      archivoBase64: {
        base64: nominaFile ? nominaFile[0].value : "",
        extension: nominaFile ? nominaFile[0].filename.split(".").pop() : "",
      },
      email,
    };
    if (bodyObj.archivoBase64.base64 !== "") {
      dispatch(validarImportacionNominas(bodyObj.archivoBase64)).then(() =>
        handleSubmitCertificado(bodyObj)
      );
    } else {
      handleSubmitCertificado(bodyObj);
    }
  };

  const handleSubmitCertificado = (bodyObj) => {
    if (bodyObj.email) {
      dispatch(enviarCertificadoCobertura(bodyObj)).then(() => {
        toast.success("Contrato enviado correctamente");
      });
    } else {
      dispatch(downloadCertificadoCobertura(bodyObj))
        .then((response) => {
          downloadFile(response.value.data, "Certificado Cobertura.pdf");
        })
        .catch(async (error) => {
          if (error.response && error.response.status === 409) {
            const data = await parseBlobToObject(error.response.data);
            if (data) {
              setErrorList(data);
              setErrorDialog(true);
            }
          }
        });
    }
  };

  return (
    <Paper>
      <HeaderForm title="Certificado de Cobertura" />
      <StyledBreadCrumb.BreadCrumbContainer>
        <Breadcrumb
          setForm={setForm}
          setFields={setBreadcrumbFields}
          fields={breadcrumbFields}
          setFromBread={() => setFromBread(true)}
          form={form}
        />
      </StyledBreadCrumb.BreadCrumbContainer>
      {
        {
          InclusiónDeCláusulas: <ClausulaContainer nextForm={handleNext} />,
          SelecciónDeNóminas: <NominaContainer handleSubmit={handleSubmit} />,
        }[form]
      }
      <ErrorsDialog
        open={errorDialog}
        handleClose={() => setErrorDialog(false)}
        errors={errorList}
      />
    </Paper>
  );
};

export default CertificadoCoberturaContainer;
